<template>
  <div class="card mt-2 mb-2 ms-5 me-5">
    <!-- <h1>{{ $store.getters.getDevelops }}</h1> -->
    <div class="card-body">
      <h4>
        <strong>Área de materia prima requerida <i>(DESARROLLO)</i></strong>
      </h4>
      <div class="table-responsive">
        <table class="mx-auto">
          <tbody>
            <tr>
              <td class="lblform">
                <strong>Longitud {{ lblDesarrollo }}</strong>
              </td>
              <td class="inputForm">
                <input type="number" min="0" class="form-control"
                  :class="{ 'avilable-input': this.getInitialLengthConception == 0 || this.lengthDevelop == 0 }"
                  id="sheetLength" v-model="lengthDevelop" />Medida en cm.
              </td>
            </tr>
            <tr>
              <td class="lblform">
                <strong>Ancho{{ lblDesarrollo }}</strong>
              </td>
              <td class="inputForm">
                <input type="number" min="0" class="form-control" :class="{ 'avilable-input': this.widthDevelop == 0 }"
                  id="sheetWidth" v-model="widthDevelop" />Medida en cm.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    getInitialLengthConception: Text,
  },
  watch: {
    lengthDevelop: function () {
      // Emitir un evento personalizado cuando lengthDevelop cambie
      this.$emit("lengthChanged", this.lengthDevelop);
    },
    widthDevelop: function () {
      // Emitir un evento personalizado cuando widthDevelop cambie
      this.$emit("widthChanged", this.widthDevelop);
    },
    "$store.getters.getDevelops": {
      handler(newDevelops) {
        this.lengthDevelop = newDevelops[0];
        this.widthDevelop = newDevelops[1];
      },
      deep: true,
    },
  },
  data() {
    return {
      lblDesarrollo: " total de materia prima:",
      lengthDevelop: 0,
      widthDevelop: 0,
    };
  },
  methods: {
  },
};
</script>
<style scoped>
.card {
  border: solid 2px #a6323b;
}

input [type="number"] {
  padding: 2px 6px 2px 16px;
  border: solid 5px #999999;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.avilable-input {
  background-color: #FCE196;
}
</style>